<app-feature-hero
    variant="itsm"
    title="Incident Management Software"
    description="Accelerate resolutions with Infraon’s Gen AI-based incident management solution"
    image="/assets/img/feature-pages/infraon-itsm/incident/incident-management-header.webp"
    imageAlt="Incident Management hero image"
></app-feature-hero>

<section class="container section-spacing">
  <div class="row mx-0 align-items-center">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <div class="illustrated-feature-container-text-left">
        <h2 class="section-title">What is an Incident Management Tool & Its Importance</h2>
        <p class="section-paragraph">
          Incident management is the heart of
          <a routerLink="/itsm-tool"
            ><b><u class="primary-color">IT Service Management (ITSM)</u></b></a
          >, focusing on quickly restoring services after unexpected disruptions. Picture this: a
          key application crashes during a business operation. Incident management steps in to
          identify the problem, diagnose it, and get everything back on track so that organizations
          can ensure smooth operations.
        </p>
        <p class="section-paragraph">
          When incidents are handled, they build trust with customers and boost the morale of the IT
          team. The data gathered during incident management helps improve IT processes, leading to
          a more proactive approach to service delivery. This means fewer surprises and more
          reliable services.
        </p>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <img
        src="/assets/img/feature-pages/infraon-itsm/incident/incident-management-feature-1.webp"
        width="100%"
        alt="What is an Incident Management Tool & Its Importance"
      />
    </div>
  </div>
</section>

<section class="container section-spacing">
  <div class="row mx-0 align-items-center reverse-col">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <img
        src="/assets/img/feature-pages/infraon-itsm/incident/incident-management-feature-2.webp"
        width="90%"
        alt="Infraon’s AI-Powered Incident Management Software"
      />
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <div class="illustrated-feature-container-text-left">
        <h2 class="section-title">Infraon’s AI-Powered Incident Management Software</h2>
        <p class="section-paragraph">
          Infraon’s incident management solution equips different teams to collaborate, track, and
          resolve incidents quickly and accurately. It comes with Gen AI-based workspace workflows
          to identify, log, and prioritize incidents and auto-assign them based on business impact.
        </p>
        <p class="section-paragraph">
          Infraon’s incident management solution provides clarity on the severity and priority
          levels and ensures prompt responses. It becomes easy to create a fully reliable and
          streamlined ITSM ecosystem.
        </p>
      </div>
    </div>
  </div>
</section>

<section class="section-spacing container">
  <div class="ai-based-itsm case-study blog d-flex align-items-center justify-content-between">
    <div>
      <small data-aos="fade-up" data-aos-delay="100" class="text-white">BLOG</small>
      <h2 data-aos="fade-up" data-aos-delay="300" class="section-title text-start text-white">
        How Incident Management Software Optimizes ITSM
      </h2>
      <p data-aos="fade-up" data-aos-delay="500" class="section-paragraph text-start text-white">
        Even a single incident can trigger a major impact. So, find out everything you must know
        about managing them.
      </p>

      <a
        href="https://infraon.io/blog/what-is-incident-management/"
        class="crmform-button text-white"
      >
        <span style="font-weight: 700; vertical-align: middle">Read blog</span>
        <svg
          style="vertical-align: middle"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H15"
            stroke="#0D51D9"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 17L15 12L10 7"
            stroke="#0D51D9"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15 12H3"
            stroke="#0D51D9"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </a>
    </div>
    <div>
      <img
        src="/assets/img/feature-pages/itsm-blog-illustration.webp"
        class="case-study-illustration m-d-none"
        alt="ITSM Blog illustration"
      />
    </div>
  </div>
</section>

<section class="container section-spacing">
  <h2 class="section-title text-center p-b-60" style="margin-bottom: 0 !important">
    Core Features of Infraon’s Incident Management Tool
  </h2>

  <div class="row mx-0 align-items-center">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <div class="illustrated-feature-container-text-left">
        <h3 class="section-title sub-title">Automated Incident Logging and Assignment</h3>
        <p class="section-paragraph sub-paragraph">
          Log incidents through email and auto-assign to agents based on skill and availability -
          resolving up to 80% of the tickets in one click.
        </p>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <img
        src="/assets/img/feature-pages/infraon-itsm/incident/itsm-change-management-feature-2-01.png"
        class="w-90"
        alt="incident report"
      />
    </div>
  </div>

  <div class="row mx-0 align-items-center section-spacing reverse-col">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <img
        src="/assets/img/feature-pages/infraon-itsm/incident/itsm-incident-management-feature-3-01.png"
        class="w-90"
        alt="ITSM incident management feature."
      />
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <div class="illustrated-feature-container-text-right">
        <h3 class="section-title sub-title">Gen AI-Driven Incident Diagnosis and Prioritization</h3>
        <p class="section-paragraph sub-paragraph">
          Categorize incidents and prioritize with Gen AI. Auto-escalate if the SLAs are not met and
          deploy a self-service portal for users.
        </p>
      </div>
    </div>
  </div>

  <div class="row mx-0 align-items-center">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <div class="illustrated-feature-container-text-left">
        <h3 class="section-title sub-title">AI-Powered Knowledge Base for Faster Resolution</h3>
        <p class="section-paragraph sub-paragraph">
          Deploy a Gen AI-driven knowledge base to offer quick solutions to common issues and
          inquiries while increasing user adoption.
        </p>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <img
        src="/assets/img/feature-pages/infraon-itsm/incident/itsm-incident-management-feature-4-01.png"
        class="w-90"
        alt="Collaborative Knowledge Base"
      />
    </div>
  </div>

  <div
    class="row mx-0 align-items-center section-spacing reverse-col"
    style="padding-bottom: 0 !important"
  >
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <img
        src="/assets/img/feature-pages/infraon-itsm/incident/itsm-incident-management-feature-5-01.png"
        class="w-90"
        alt="Gen AI-Powered Dashboard"
      />
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <div class="illustrated-feature-container-text-right">
        <h3 class="section-title sub-title">Real-Time Analytics with Gen AI Dashboard</h3>
        <p class="section-paragraph sub-paragraph">
          Get full visibility into incident management, send alerts – as required, track anomalies
          in real time, and discover root causes for incidents.
        </p>
      </div>
    </div>
  </div>
</section>

<section class="container section-spacing pt-0">
  <div class="row mx-0 d-flex align-items-center position-relative">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 section-spacing">
      <h2 class="section-title">
        Additional Capabilities of Infraon’s IT Incident Management Tool
      </h2>

      <div class="row mx-0 px-0">
        <ul class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0">
          <li class="d-flex align-items-center my-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.33905 22.0001 6.83605 20.9681 4.94905 19.0911C3.05505 17.2081 2.00805 14.7001 2.00005 12.0291C1.99205 9.35712 3.02505 6.84312 4.90905 4.94912C6.79205 3.05512 9.30005 2.00812 11.971 2.00012C12.766 2.01212 13.576 2.09212 14.352 2.27812C14.888 2.40812 15.219 2.94812 15.089 3.48512C14.96 4.02112 14.417 4.35112 13.883 4.22312C13.262 4.07312 12.603 4.01012 11.977 4.00012C9.84005 4.00612 7.83305 4.84412 6.32705 6.35912C4.82005 7.87412 3.99405 9.88612 4.00005 12.0231C4.00605 14.1601 4.84405 16.1661 6.35905 17.6731C7.86905 19.1741 9.87105 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.29305 11.293C8.68405 10.902 9.31605 10.902 9.70705 11.293L11.951 13.537L18.248 6.34102C18.612 5.92802 19.243 5.88402 19.659 6.24802C20.074 6.61102 20.116 7.24302 19.752 7.65902L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.29305 12.707C7.90205 12.316 7.90205 11.684 8.29305 11.293Z"
                fill="#231F20"
              />
              <mask
                id="mask0_2106_28640"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="2"
                y="2"
                width="21"
                height="21"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.33905 22.0001 6.83605 20.9681 4.94905 19.0911C3.05505 17.2081 2.00805 14.7001 2.00005 12.0291C1.99205 9.35712 3.02505 6.84312 4.90905 4.94912C6.79205 3.05512 9.30005 2.00812 11.971 2.00012C12.766 2.01212 13.576 2.09212 14.352 2.27812C14.888 2.40812 15.219 2.94812 15.089 3.48512C14.96 4.02112 14.417 4.35112 13.883 4.22312C13.262 4.07312 12.603 4.01012 11.977 4.00012C9.84005 4.00612 7.83305 4.84412 6.32705 6.35912C4.82005 7.87412 3.99405 9.88612 4.00005 12.0231C4.00605 14.1601 4.84405 16.1661 6.35905 17.6731C7.86905 19.1741 9.87105 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.29305 11.293C8.68405 10.902 9.31605 10.902 9.70705 11.293L11.951 13.537L18.248 6.34102C18.612 5.92802 19.243 5.88402 19.659 6.24802C20.074 6.61102 20.116 7.24302 19.752 7.65902L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.29305 12.707C7.90205 12.316 7.90205 11.684 8.29305 11.293Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_2106_28640)"><rect width="24" height="24" fill="#0D51D9" /></g>
            </svg>
            <p class="section-paragraph ms-2 mb-0">Setting Severity Levels</p>
          </li>
          <li class="d-flex align-items-center my-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.33905 22.0001 6.83605 20.9681 4.94905 19.0911C3.05505 17.2081 2.00805 14.7001 2.00005 12.0291C1.99205 9.35712 3.02505 6.84312 4.90905 4.94912C6.79205 3.05512 9.30005 2.00812 11.971 2.00012C12.766 2.01212 13.576 2.09212 14.352 2.27812C14.888 2.40812 15.219 2.94812 15.089 3.48512C14.96 4.02112 14.417 4.35112 13.883 4.22312C13.262 4.07312 12.603 4.01012 11.977 4.00012C9.84005 4.00612 7.83305 4.84412 6.32705 6.35912C4.82005 7.87412 3.99405 9.88612 4.00005 12.0231C4.00605 14.1601 4.84405 16.1661 6.35905 17.6731C7.86905 19.1741 9.87105 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.29305 11.293C8.68405 10.902 9.31605 10.902 9.70705 11.293L11.951 13.537L18.248 6.34102C18.612 5.92802 19.243 5.88402 19.659 6.24802C20.074 6.61102 20.116 7.24302 19.752 7.65902L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.29305 12.707C7.90205 12.316 7.90205 11.684 8.29305 11.293Z"
                fill="#231F20"
              />
              <mask
                id="mask0_2106_28640"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="2"
                y="2"
                width="21"
                height="21"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.33905 22.0001 6.83605 20.9681 4.94905 19.0911C3.05505 17.2081 2.00805 14.7001 2.00005 12.0291C1.99205 9.35712 3.02505 6.84312 4.90905 4.94912C6.79205 3.05512 9.30005 2.00812 11.971 2.00012C12.766 2.01212 13.576 2.09212 14.352 2.27812C14.888 2.40812 15.219 2.94812 15.089 3.48512C14.96 4.02112 14.417 4.35112 13.883 4.22312C13.262 4.07312 12.603 4.01012 11.977 4.00012C9.84005 4.00612 7.83305 4.84412 6.32705 6.35912C4.82005 7.87412 3.99405 9.88612 4.00005 12.0231C4.00605 14.1601 4.84405 16.1661 6.35905 17.6731C7.86905 19.1741 9.87105 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.29305 11.293C8.68405 10.902 9.31605 10.902 9.70705 11.293L11.951 13.537L18.248 6.34102C18.612 5.92802 19.243 5.88402 19.659 6.24802C20.074 6.61102 20.116 7.24302 19.752 7.65902L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.29305 12.707C7.90205 12.316 7.90205 11.684 8.29305 11.293Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_2106_28640)"><rect width="24" height="24" fill="#0D51D9" /></g>
            </svg>
            <p class="section-paragraph ms-2 mb-0">User and Role Management</p>
          </li>
          <li class="d-flex align-items-center my-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.33905 22.0001 6.83605 20.9681 4.94905 19.0911C3.05505 17.2081 2.00805 14.7001 2.00005 12.0291C1.99205 9.35712 3.02505 6.84312 4.90905 4.94912C6.79205 3.05512 9.30005 2.00812 11.971 2.00012C12.766 2.01212 13.576 2.09212 14.352 2.27812C14.888 2.40812 15.219 2.94812 15.089 3.48512C14.96 4.02112 14.417 4.35112 13.883 4.22312C13.262 4.07312 12.603 4.01012 11.977 4.00012C9.84005 4.00612 7.83305 4.84412 6.32705 6.35912C4.82005 7.87412 3.99405 9.88612 4.00005 12.0231C4.00605 14.1601 4.84405 16.1661 6.35905 17.6731C7.86905 19.1741 9.87105 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.29305 11.293C8.68405 10.902 9.31605 10.902 9.70705 11.293L11.951 13.537L18.248 6.34102C18.612 5.92802 19.243 5.88402 19.659 6.24802C20.074 6.61102 20.116 7.24302 19.752 7.65902L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.29305 12.707C7.90205 12.316 7.90205 11.684 8.29305 11.293Z"
                fill="#231F20"
              />
              <mask
                id="mask0_2106_28640"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="2"
                y="2"
                width="21"
                height="21"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.33905 22.0001 6.83605 20.9681 4.94905 19.0911C3.05505 17.2081 2.00805 14.7001 2.00005 12.0291C1.99205 9.35712 3.02505 6.84312 4.90905 4.94912C6.79205 3.05512 9.30005 2.00812 11.971 2.00012C12.766 2.01212 13.576 2.09212 14.352 2.27812C14.888 2.40812 15.219 2.94812 15.089 3.48512C14.96 4.02112 14.417 4.35112 13.883 4.22312C13.262 4.07312 12.603 4.01012 11.977 4.00012C9.84005 4.00612 7.83305 4.84412 6.32705 6.35912C4.82005 7.87412 3.99405 9.88612 4.00005 12.0231C4.00605 14.1601 4.84405 16.1661 6.35905 17.6731C7.86905 19.1741 9.87105 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.29305 11.293C8.68405 10.902 9.31605 10.902 9.70705 11.293L11.951 13.537L18.248 6.34102C18.612 5.92802 19.243 5.88402 19.659 6.24802C20.074 6.61102 20.116 7.24302 19.752 7.65902L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.29305 12.707C7.90205 12.316 7.90205 11.684 8.29305 11.293Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_2106_28640)"><rect width="24" height="24" fill="#0D51D9" /></g>
            </svg>
            <p class="section-paragraph ms-2 mb-0">Custom Analytics</p>
          </li>
          <li class="d-flex align-items-center my-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.33905 22.0001 6.83605 20.9681 4.94905 19.0911C3.05505 17.2081 2.00805 14.7001 2.00005 12.0291C1.99205 9.35712 3.02505 6.84312 4.90905 4.94912C6.79205 3.05512 9.30005 2.00812 11.971 2.00012C12.766 2.01212 13.576 2.09212 14.352 2.27812C14.888 2.40812 15.219 2.94812 15.089 3.48512C14.96 4.02112 14.417 4.35112 13.883 4.22312C13.262 4.07312 12.603 4.01012 11.977 4.00012C9.84005 4.00612 7.83305 4.84412 6.32705 6.35912C4.82005 7.87412 3.99405 9.88612 4.00005 12.0231C4.00605 14.1601 4.84405 16.1661 6.35905 17.6731C7.86905 19.1741 9.87105 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.29305 11.293C8.68405 10.902 9.31605 10.902 9.70705 11.293L11.951 13.537L18.248 6.34102C18.612 5.92802 19.243 5.88402 19.659 6.24802C20.074 6.61102 20.116 7.24302 19.752 7.65902L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.29305 12.707C7.90205 12.316 7.90205 11.684 8.29305 11.293Z"
                fill="#231F20"
              />
              <mask
                id="mask0_2106_28640"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="2"
                y="2"
                width="21"
                height="21"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.33905 22.0001 6.83605 20.9681 4.94905 19.0911C3.05505 17.2081 2.00805 14.7001 2.00005 12.0291C1.99205 9.35712 3.02505 6.84312 4.90905 4.94912C6.79205 3.05512 9.30005 2.00812 11.971 2.00012C12.766 2.01212 13.576 2.09212 14.352 2.27812C14.888 2.40812 15.219 2.94812 15.089 3.48512C14.96 4.02112 14.417 4.35112 13.883 4.22312C13.262 4.07312 12.603 4.01012 11.977 4.00012C9.84005 4.00612 7.83305 4.84412 6.32705 6.35912C4.82005 7.87412 3.99405 9.88612 4.00005 12.0231C4.00605 14.1601 4.84405 16.1661 6.35905 17.6731C7.86905 19.1741 9.87105 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.29305 11.293C8.68405 10.902 9.31605 10.902 9.70705 11.293L11.951 13.537L18.248 6.34102C18.612 5.92802 19.243 5.88402 19.659 6.24802C20.074 6.61102 20.116 7.24302 19.752 7.65902L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.29305 12.707C7.90205 12.316 7.90205 11.684 8.29305 11.293Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_2106_28640)"><rect width="24" height="24" fill="#0D51D9" /></g>
            </svg>
            <p class="section-paragraph ms-2 mb-0">Mobile Accessibility</p>
          </li>
        </ul>
      </div>
      <div class="py-3">
        <a
          [routerLink]="['/registration']"
          [queryParams]="{ type: 'trial' }"
          class="primary-buttons cta-buttons rounded-full"
          >Get started with free trial</a
        >
      </div>
    </div>

    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
      <img
        src="/assets/img/feature-pages/infraon-itsm/incident/itsm-change-management-feature-5-01.svg"
        class="float-end m-d-none"
        alt="Other Service"
      />
    </div>
  </div>
</section>

<section class="section-spacing container">
  <div
    class="ai-based-itsm ebook d-flex align-items-center justify-content-between primary-bg position-relative"
  >
    <div>
      <small data-aos="fade-up" data-aos-delay="100">EBOOK</small>
      <h2 data-aos="fade-up" data-aos-delay="300" class="section-title text-start">
        ITSM Essentials: <br />
        A Comprehensive Checklist
      </h2>
      <p data-aos="fade-up" data-aos-delay="500" class="section-paragraph text-start">
        Learn how to overcome ITSM challenges with workflow automation, AI, etc., <br />
        and keep operations running smoothly.
      </p>

      <a [routerLink]="['/resources', 'ebook', 'future-of-customer-experience']" class="crmform-button">
        <span class="me-1">Download our e-book</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="19"
          viewBox="0 0 18 19"
          fill="none"
        >
          <path
            d="M10.125 1.375V9.91797L12.6914 7.35156C13.1133 6.89453 13.8516 6.89453 14.2734 7.35156C14.7305 7.77344 14.7305 8.51172 14.2734 8.93359L9.77344 13.4336C9.35156 13.8906 8.61328 13.8906 8.19141 13.4336L3.69141 8.93359C3.23438 8.51172 3.23438 7.77344 3.69141 7.35156C4.11328 6.89453 4.85156 6.89453 5.27344 7.35156L7.875 9.91797V1.375C7.875 0.777344 8.36719 0.25 9 0.25C9.59766 0.25 10.125 0.777344 10.125 1.375ZM2.25 12.625H5.80078L7.38281 14.2422C8.26172 15.1211 9.70312 15.1211 10.582 14.2422L12.1641 12.625H15.75C16.9805 12.625 18 13.6445 18 14.875V16C18 17.2656 16.9805 18.25 15.75 18.25H2.25C0.984375 18.25 0 17.2656 0 16V14.875C0 13.6445 0.984375 12.625 2.25 12.625ZM15.1875 16.2812C15.6445 16.2812 16.0312 15.9297 16.0312 15.4375C16.0312 14.9805 15.6445 14.5938 15.1875 14.5938C14.6953 14.5938 14.3438 14.9805 14.3438 15.4375C14.3438 15.9297 14.6953 16.2812 15.1875 16.2812Z"
            fill="#0D51D9"
          />
        </svg>
      </a>
    </div>
    <img
      src="/assets/img/feature-pages/asset-management-ebook.webp"
      class="asset-mmanagement-ebook m-d-none"
      alt="asset mmanagement ebook"
    />
  </div>
</section>

<section class="container section-spacing features">
  <h2 class="section-title p-b-60 mb-0">Maximizing Incident Management with Infraon</h2>

  <div class="row mx-0 feature-box">
    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-5">
      <div class="feature-wrapper">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="29"
          height="25"
          viewBox="0 0 29 25"
          fill="none"
        >
          <path
            d="M15 0.25C15.7656 0.25 16.4766 0.6875 16.8594 1.34375L28.6719 21.4688C29.0547 22.1797 29.0547 23 28.6719 23.6562C28.2891 24.3672 27.5781 24.75 26.8125 24.75H3.1875C2.36719 24.75 1.65625 24.3672 1.27344 23.6562C0.890625 23 0.890625 22.1797 1.27344 21.4688L13.0859 1.34375C13.4688 0.6875 14.1797 0.25 15 0.25ZM15 7.25C14.2344 7.25 13.6875 7.85156 13.6875 8.5625V14.6875C13.6875 15.4531 14.2344 16 15 16C15.7109 16 16.3125 15.4531 16.3125 14.6875V8.5625C16.3125 7.85156 15.7109 7.25 15 7.25ZM16.75 19.5C16.75 18.5703 15.9297 17.75 15 17.75C14.0156 17.75 13.25 18.5703 13.25 19.5C13.25 20.4844 14.0156 21.25 15 21.25C15.9297 21.25 16.75 20.4844 16.75 19.5Z"
            fill="#084CD4"
          />
        </svg>
        <h3 class="section-title-s text-start pt-3">
          Early Detection with AI for Incident <br />Prevention
        </h3>
        <p class="section-paragraph-s text-start">
          A proactive approach to incident detection ensures potential issues are identified on
          time. Infraon’s incident management solution helps:
        </p>
        <ul style="list-style: disc !important; padding: 0 17px !important">
          <li class="section-paragraph-s text-start">Continuously monitor IT infra</li>
          <li class="section-paragraph-s text-start">Detect potential incidents early</li>
          <li class="section-paragraph-s text-start">Minimize incident escalation</li>
          <li class="section-paragraph-s text-start">Boost business continuity</li>
        </ul>
      </div>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
      <div class="feature-wrapper">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
        >
          <path
            d="M0.25 10.75H7.25V24.75H0.25V10.75ZM24.75 3.75V24.75H17.75V3.75H24.75Z"
            fill="#084CD4"
          />
          <path d="M9 0H16V24.7043H9V0Z" fill="#A8C1F1" />
        </svg>
        <h3 class="section-title-s text-start pt-3">
          Intelligent Diagnosis for Swift Incident Resolution
        </h3>
        <p class="section-paragraph-s text-start">
          Incident diagnosis allows IT teams to quickly understand and address the root causes.
          Infraon’s incident management solution allows you to:
        </p>
        <ul style="list-style: disc !important; padding: 0 17px !important">
          <li class="section-paragraph-s text-start">Analyze real-time incident data</li>
          <li class="section-paragraph-s text-start">Reduce time to resolution</li>
          <li class="section-paragraph-s text-start">Eliminate repeat incidents</li>
          <li class="section-paragraph-s text-start">Improve incident handling</li>
        </ul>
      </div>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
      <div class="feature-wrapper">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="28"
          viewBox="0 0 35 28"
          fill="none"
        >
          <path d="M3.5 12.75V23.25H0V12.75H3.5ZM35 12.75V23.25H31.5V12.75H35Z" fill="#A8C1F1" />
          <path
            d="M19 0V1.75V5.25H29.5V28H5V5.25H15.5V1.75V0H19ZM14.1875 14C14.1875 12.7969 13.2031 11.8125 12 11.8125C10.7422 11.8125 9.8125 12.7969 9.8125 14C9.8125 15.2578 10.7422 16.1875 12 16.1875C13.2031 16.1875 14.1875 15.2578 14.1875 14ZM22.5 16.1875C23.7031 16.1875 24.6875 15.2578 24.6875 14C24.6875 12.7969 23.7031 11.8125 22.5 11.8125C21.2422 11.8125 20.3125 12.7969 20.3125 14C20.3125 15.2578 21.2422 16.1875 22.5 16.1875Z"
            fill="#084CD4"
          />
          <rect x="10" y="21" width="14" height="2" rx="1" fill="#A8C0F1" />
        </svg>
        <h3 class="section-title-s text-start pt-3">
          Streamlined Incident Resolution through Automation
        </h3>
        <p class="section-paragraph-s text-start">
          Automating the resolution frees up IT teams to focus on more strategic tasks. Infraon’s
          incident management solution equips teams to:
        </p>
        <ul style="list-style: disc !important; padding: 0 17px !important">
          <li class="section-paragraph-s text-start">Accelerate response times</li>
          <li class="section-paragraph-s text-start">Reduce manual effort</li>
          <li class="section-paragraph-s text-start">Enhance team productivity</li>
          <li class="section-paragraph-s text-start">Get smart recommendations</li>
        </ul>
      </div>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
      <div class="feature-wrapper">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="28"
          viewBox="0 0 21 28"
          fill="none"
        >
          <path d="M0 0H12.25V8.75H21V28H0V0Z" fill="#084CD4" />
          <path d="M21 7H14V0L21 7Z" fill="#A8C1F1" />
        </svg>
        <h3 class="section-title-s text-start pt-3">
          In-Depth Reporting and Analytics for Incident Management
        </h3>
        <p class="section-paragraph-s text-start">
          It is important to know everything you can about the incident lifecycle. Infraon’s
          incident management solution makes it easy to:
        </p>
        <ul style="list-style: disc !important; padding: 0 17px !important">
          <li class="section-paragraph-s text-start">Analyze trends and patterns</li>
          <li class="section-paragraph-s text-start">Decide based on data</li>
          <li class="section-paragraph-s text-start">Identify process inefficiencies</li>
          <li class="section-paragraph-s text-start">Prevent future incidents</li>
        </ul>
      </div>
    </div>
  </div>
</section>

<section class="section-spacing container">
  <div
    class="ai-based-itsm case-study d-flex align-items-center justify-content-between bg-grey"
    style="background-image: none"
  >
    <div>
      <small data-aos="fade-up" data-aos-delay="100">CASE STUDY</small>
      <h2 data-aos="fade-up" data-aos-delay="300" class="section-title text-start">
        Impact of Our Gen AI-Based ITSM Software on a Leading Electronic Distributor
      </h2>
      <div class="case-study-pointers">
        <div>
          <span></span>
          <span>Customer satisfaction – up by >75%</span>
        </div>
        <div>
          <span></span>
          <span>Agent productivity – up by >75%</span>
        </div>
        <div>
          <span></span>
          <span>Compliance levels – up by >75%</span>
        </div>
        <div>
          <span></span>
          <span>IT expenses – down by >75%</span>
        </div>
      </div>

      <a [routerLink]="['/resources', 'case-studies', 'smet']" class="crmform-button">
        <span style="color: #0d51d9 !important; font-weight: 700">Download Case-study</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="19"
          viewBox="0 0 18 19"
          fill="none"
        >
          <path
            d="M10.125 1.375V9.91797L12.6914 7.35156C13.1133 6.89453 13.8516 6.89453 14.2734 7.35156C14.7305 7.77344 14.7305 8.51172 14.2734 8.93359L9.77344 13.4336C9.35156 13.8906 8.61328 13.8906 8.19141 13.4336L3.69141 8.93359C3.23438 8.51172 3.23438 7.77344 3.69141 7.35156C4.11328 6.89453 4.85156 6.89453 5.27344 7.35156L7.875 9.91797V1.375C7.875 0.777344 8.36719 0.25 9 0.25C9.59766 0.25 10.125 0.777344 10.125 1.375ZM2.25 12.625H5.80078L7.38281 14.2422C8.26172 15.1211 9.70312 15.1211 10.582 14.2422L12.1641 12.625H15.75C16.9805 12.625 18 13.6445 18 14.875V16C18 17.2656 16.9805 18.25 15.75 18.25H2.25C0.984375 18.25 0 17.2656 0 16V14.875C0 13.6445 0.984375 12.625 2.25 12.625ZM15.1875 16.2812C15.6445 16.2812 16.0312 15.9297 16.0312 15.4375C16.0312 14.9805 15.6445 14.5938 15.1875 14.5938C14.6953 14.5938 14.3438 14.9805 14.3438 15.4375C14.3438 15.9297 14.6953 16.2812 15.1875 16.2812Z"
            fill="#1A5AD9"
          />
        </svg>
      </a>
    </div>
    <div>
      <img
        src="/assets/img/feature-pages/case-study-illustration.webp"
        class="case-study-illustration m-d-none"
        alt="Case Study Illurtation"
      />
    </div>
  </div>
</section>

<section class="container section-spacing">
  <div class="row align-items-center reverse-col">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <img
        src="/assets/img/feature-pages/infraon-itsm/incident/incident-management-feature-3.webp"
        class="w-100"
        style="box-shadow: none"
        alt="it asset management software"
      />
    </div>

    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <div class="illustrated-feature-container-text-left">
        <h2 class="section-title">Best Practices for Using the Incident Management Tool</h2>
        <p class="section-paragraph">
          Infraon's incident management solution is based on best practices, such as:
        </p>

        <div class="d-flex align-items-start mb-3" style="gap: 8px">
          <svg
            style="width: 16px; min-width: 16px"
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="22"
            viewBox="0 0 21 22"
            fill="none"
          >
            <path
              d="M9.63867 14.2422C9.39258 14.4883 8.94141 14.4883 8.69531 14.2422L6.07031 11.6172C5.82422 11.3711 5.82422 10.9199 6.07031 10.6738C6.31641 10.4277 6.76758 10.4277 7.01367 10.6738L9.1875 12.8477L13.9453 8.04883C14.1914 7.80273 14.6426 7.80273 14.8887 8.04883C15.1348 8.29492 15.1348 8.74609 14.8887 8.99219L9.63867 14.2422ZM21 11.125C21 16.9492 16.2832 21.625 10.5 21.625C4.67578 21.625 0 16.9492 0 11.125C0 5.3418 4.67578 0.625 10.5 0.625C16.2832 0.625 21 5.3418 21 11.125ZM10.5 1.9375C5.41406 1.9375 1.3125 6.08008 1.3125 11.125C1.3125 16.2109 5.41406 20.3125 10.5 20.3125C15.5449 20.3125 19.6875 16.2109 19.6875 11.125C19.6875 6.08008 15.5449 1.9375 10.5 1.9375Z"
              fill="#4B4B4B"
            />
          </svg>
          <p class="section-paragraph-s text-start mb-0">
            Monitoring tools for identifying issues before they escalate into major incidents
          </p>
        </div>
        <div class="d-flex align-items-start mb-3" style="gap: 8px">
          <svg
            style="width: 16px; min-width: 16px"
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="22"
            viewBox="0 0 21 22"
            fill="none"
          >
            <path
              d="M9.63867 14.2422C9.39258 14.4883 8.94141 14.4883 8.69531 14.2422L6.07031 11.6172C5.82422 11.3711 5.82422 10.9199 6.07031 10.6738C6.31641 10.4277 6.76758 10.4277 7.01367 10.6738L9.1875 12.8477L13.9453 8.04883C14.1914 7.80273 14.6426 7.80273 14.8887 8.04883C15.1348 8.29492 15.1348 8.74609 14.8887 8.99219L9.63867 14.2422ZM21 11.125C21 16.9492 16.2832 21.625 10.5 21.625C4.67578 21.625 0 16.9492 0 11.125C0 5.3418 4.67578 0.625 10.5 0.625C16.2832 0.625 21 5.3418 21 11.125ZM10.5 1.9375C5.41406 1.9375 1.3125 6.08008 1.3125 11.125C1.3125 16.2109 5.41406 20.3125 10.5 20.3125C15.5449 20.3125 19.6875 16.2109 19.6875 11.125C19.6875 6.08008 15.5449 1.9375 10.5 1.9375Z"
              fill="#4B4B4B"
            />
          </svg>
          <p class="section-paragraph-s text-start mb-0">
            Classification system to prioritize incidents based on impact and urgency
          </p>
        </div>
        <div class="d-flex align-items-start mb-3" style="gap: 8px">
          <svg
            style="width: 16px; min-width: 16px"
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="22"
            viewBox="0 0 21 22"
            fill="none"
          >
            <path
              d="M9.63867 14.2422C9.39258 14.4883 8.94141 14.4883 8.69531 14.2422L6.07031 11.6172C5.82422 11.3711 5.82422 10.9199 6.07031 10.6738C6.31641 10.4277 6.76758 10.4277 7.01367 10.6738L9.1875 12.8477L13.9453 8.04883C14.1914 7.80273 14.6426 7.80273 14.8887 8.04883C15.1348 8.29492 15.1348 8.74609 14.8887 8.99219L9.63867 14.2422ZM21 11.125C21 16.9492 16.2832 21.625 10.5 21.625C4.67578 21.625 0 16.9492 0 11.125C0 5.3418 4.67578 0.625 10.5 0.625C16.2832 0.625 21 5.3418 21 11.125ZM10.5 1.9375C5.41406 1.9375 1.3125 6.08008 1.3125 11.125C1.3125 16.2109 5.41406 20.3125 10.5 20.3125C15.5449 20.3125 19.6875 16.2109 19.6875 11.125C19.6875 6.08008 15.5449 1.9375 10.5 1.9375Z"
              fill="#4B4B4B"
            />
          </svg>
          <p class="section-paragraph-s text-start mb-0">
            Automation to handle routine tasks that frees IT staff to focus on more complex
            incidents
          </p>
        </div>
        <div class="d-flex align-items-start mb-3" style="gap: 8px">
          <svg
            style="width: 16px; min-width: 16px"
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="22"
            viewBox="0 0 21 22"
            fill="none"
          >
            <path
              d="M9.63867 14.2422C9.39258 14.4883 8.94141 14.4883 8.69531 14.2422L6.07031 11.6172C5.82422 11.3711 5.82422 10.9199 6.07031 10.6738C6.31641 10.4277 6.76758 10.4277 7.01367 10.6738L9.1875 12.8477L13.9453 8.04883C14.1914 7.80273 14.6426 7.80273 14.8887 8.04883C15.1348 8.29492 15.1348 8.74609 14.8887 8.99219L9.63867 14.2422ZM21 11.125C21 16.9492 16.2832 21.625 10.5 21.625C4.67578 21.625 0 16.9492 0 11.125C0 5.3418 4.67578 0.625 10.5 0.625C16.2832 0.625 21 5.3418 21 11.125ZM10.5 1.9375C5.41406 1.9375 1.3125 6.08008 1.3125 11.125C1.3125 16.2109 5.41406 20.3125 10.5 20.3125C15.5449 20.3125 19.6875 16.2109 19.6875 11.125C19.6875 6.08008 15.5449 1.9375 10.5 1.9375Z"
              fill="#4B4B4B"
            />
          </svg>
          <p class="section-paragraph-s text-start mb-0">
            Incident logs to keep records, including causes, resolutions, and follow-up actions
          </p>
        </div>
        <div class="d-flex align-items-start mb-3" style="gap: 8px">
          <svg
            style="width: 16px; min-width: 16px"
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="22"
            viewBox="0 0 21 22"
            fill="none"
          >
            <path
              d="M9.63867 14.2422C9.39258 14.4883 8.94141 14.4883 8.69531 14.2422L6.07031 11.6172C5.82422 11.3711 5.82422 10.9199 6.07031 10.6738C6.31641 10.4277 6.76758 10.4277 7.01367 10.6738L9.1875 12.8477L13.9453 8.04883C14.1914 7.80273 14.6426 7.80273 14.8887 8.04883C15.1348 8.29492 15.1348 8.74609 14.8887 8.99219L9.63867 14.2422ZM21 11.125C21 16.9492 16.2832 21.625 10.5 21.625C4.67578 21.625 0 16.9492 0 11.125C0 5.3418 4.67578 0.625 10.5 0.625C16.2832 0.625 21 5.3418 21 11.125ZM10.5 1.9375C5.41406 1.9375 1.3125 6.08008 1.3125 11.125C1.3125 16.2109 5.41406 20.3125 10.5 20.3125C15.5449 20.3125 19.6875 16.2109 19.6875 11.125C19.6875 6.08008 15.5449 1.9375 10.5 1.9375Z"
              fill="#4B4B4B"
            />
          </svg>
          <p class="section-paragraph-s text-start mb-0">
            Regular training to ensure IT stakeholders are regularly trained to stay updated
          </p>
        </div>
        <div class="d-flex align-items-start mb-3" style="gap: 8px">
          <svg
            style="width: 16px; min-width: 16px"
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="22"
            viewBox="0 0 21 22"
            fill="none"
          >
            <path
              d="M9.63867 14.2422C9.39258 14.4883 8.94141 14.4883 8.69531 14.2422L6.07031 11.6172C5.82422 11.3711 5.82422 10.9199 6.07031 10.6738C6.31641 10.4277 6.76758 10.4277 7.01367 10.6738L9.1875 12.8477L13.9453 8.04883C14.1914 7.80273 14.6426 7.80273 14.8887 8.04883C15.1348 8.29492 15.1348 8.74609 14.8887 8.99219L9.63867 14.2422ZM21 11.125C21 16.9492 16.2832 21.625 10.5 21.625C4.67578 21.625 0 16.9492 0 11.125C0 5.3418 4.67578 0.625 10.5 0.625C16.2832 0.625 21 5.3418 21 11.125ZM10.5 1.9375C5.41406 1.9375 1.3125 6.08008 1.3125 11.125C1.3125 16.2109 5.41406 20.3125 10.5 20.3125C15.5449 20.3125 19.6875 16.2109 19.6875 11.125C19.6875 6.08008 15.5449 1.9375 10.5 1.9375Z"
              fill="#4B4B4B"
            />
          </svg>
          <p class="section-paragraph-s text-start mb-0">
            Periodic review of performance metrics to identify areas for improvement
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="container section-spacing">
  <div class="row align-items-center">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <div class="illustrated-feature-container-text-left">
        <h2 class="section-title">Key Benefits of Implementing Incident Management Software</h2>
        <p class="section-paragraph">
          Infraon's incident management solution leads to business benefits such as:
        </p>

        <div class="d-flex align-items-start mb-3" style="gap: 8px">
          <svg
            style="width: 16px; min-width: 16px"
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="22"
            viewBox="0 0 21 22"
            fill="none"
          >
            <path
              d="M9.63867 14.2422C9.39258 14.4883 8.94141 14.4883 8.69531 14.2422L6.07031 11.6172C5.82422 11.3711 5.82422 10.9199 6.07031 10.6738C6.31641 10.4277 6.76758 10.4277 7.01367 10.6738L9.1875 12.8477L13.9453 8.04883C14.1914 7.80273 14.6426 7.80273 14.8887 8.04883C15.1348 8.29492 15.1348 8.74609 14.8887 8.99219L9.63867 14.2422ZM21 11.125C21 16.9492 16.2832 21.625 10.5 21.625C4.67578 21.625 0 16.9492 0 11.125C0 5.3418 4.67578 0.625 10.5 0.625C16.2832 0.625 21 5.3418 21 11.125ZM10.5 1.9375C5.41406 1.9375 1.3125 6.08008 1.3125 11.125C1.3125 16.2109 5.41406 20.3125 10.5 20.3125C15.5449 20.3125 19.6875 16.2109 19.6875 11.125C19.6875 6.08008 15.5449 1.9375 10.5 1.9375Z"
              fill="#4B4B4B"
            />
          </svg>
          <p class="section-paragraph-s text-start mb-0">
            Reduced downtime by minimizing the duration and impact of service disruptions
          </p>
        </div>
        <div class="d-flex align-items-start mb-3" style="gap: 8px">
          <svg
            style="width: 16px; min-width: 16px"
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="22"
            viewBox="0 0 21 22"
            fill="none"
          >
            <path
              d="M9.63867 14.2422C9.39258 14.4883 8.94141 14.4883 8.69531 14.2422L6.07031 11.6172C5.82422 11.3711 5.82422 10.9199 6.07031 10.6738C6.31641 10.4277 6.76758 10.4277 7.01367 10.6738L9.1875 12.8477L13.9453 8.04883C14.1914 7.80273 14.6426 7.80273 14.8887 8.04883C15.1348 8.29492 15.1348 8.74609 14.8887 8.99219L9.63867 14.2422ZM21 11.125C21 16.9492 16.2832 21.625 10.5 21.625C4.67578 21.625 0 16.9492 0 11.125C0 5.3418 4.67578 0.625 10.5 0.625C16.2832 0.625 21 5.3418 21 11.125ZM10.5 1.9375C5.41406 1.9375 1.3125 6.08008 1.3125 11.125C1.3125 16.2109 5.41406 20.3125 10.5 20.3125C15.5449 20.3125 19.6875 16.2109 19.6875 11.125C19.6875 6.08008 15.5449 1.9375 10.5 1.9375Z"
              fill="#4B4B4B"
            />
          </svg>
          <p class="section-paragraph-s text-start mb-0">
            Improved service quality by promptly addressing incidents
          </p>
        </div>
        <div class="d-flex align-items-start mb-3" style="gap: 8px">
          <svg
            style="width: 16px; min-width: 16px"
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="22"
            viewBox="0 0 21 22"
            fill="none"
          >
            <path
              d="M9.63867 14.2422C9.39258 14.4883 8.94141 14.4883 8.69531 14.2422L6.07031 11.6172C5.82422 11.3711 5.82422 10.9199 6.07031 10.6738C6.31641 10.4277 6.76758 10.4277 7.01367 10.6738L9.1875 12.8477L13.9453 8.04883C14.1914 7.80273 14.6426 7.80273 14.8887 8.04883C15.1348 8.29492 15.1348 8.74609 14.8887 8.99219L9.63867 14.2422ZM21 11.125C21 16.9492 16.2832 21.625 10.5 21.625C4.67578 21.625 0 16.9492 0 11.125C0 5.3418 4.67578 0.625 10.5 0.625C16.2832 0.625 21 5.3418 21 11.125ZM10.5 1.9375C5.41406 1.9375 1.3125 6.08008 1.3125 11.125C1.3125 16.2109 5.41406 20.3125 10.5 20.3125C15.5449 20.3125 19.6875 16.2109 19.6875 11.125C19.6875 6.08008 15.5449 1.9375 10.5 1.9375Z"
              fill="#4B4B4B"
            />
          </svg>
          <p class="section-paragraph-s text-start mb-0">
            Higher productivity with automation- based incident handling
          </p>
        </div>
        <div class="d-flex align-items-start mb-3" style="gap: 8px">
          <svg
            style="width: 16px; min-width: 16px"
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="22"
            viewBox="0 0 21 22"
            fill="none"
          >
            <path
              d="M9.63867 14.2422C9.39258 14.4883 8.94141 14.4883 8.69531 14.2422L6.07031 11.6172C5.82422 11.3711 5.82422 10.9199 6.07031 10.6738C6.31641 10.4277 6.76758 10.4277 7.01367 10.6738L9.1875 12.8477L13.9453 8.04883C14.1914 7.80273 14.6426 7.80273 14.8887 8.04883C15.1348 8.29492 15.1348 8.74609 14.8887 8.99219L9.63867 14.2422ZM21 11.125C21 16.9492 16.2832 21.625 10.5 21.625C4.67578 21.625 0 16.9492 0 11.125C0 5.3418 4.67578 0.625 10.5 0.625C16.2832 0.625 21 5.3418 21 11.125ZM10.5 1.9375C5.41406 1.9375 1.3125 6.08008 1.3125 11.125C1.3125 16.2109 5.41406 20.3125 10.5 20.3125C15.5449 20.3125 19.6875 16.2109 19.6875 11.125C19.6875 6.08008 15.5449 1.9375 10.5 1.9375Z"
              fill="#4B4B4B"
            />
          </svg>
          <p class="section-paragraph-s text-start mb-0">
            Proactive issue resolution with continuous monitoring and proactive issue detection
          </p>
        </div>
        <div class="d-flex align-items-start mb-3" style="gap: 8px">
          <svg
            style="width: 16px; min-width: 16px"
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="22"
            viewBox="0 0 21 22"
            fill="none"
          >
            <path
              d="M9.63867 14.2422C9.39258 14.4883 8.94141 14.4883 8.69531 14.2422L6.07031 11.6172C5.82422 11.3711 5.82422 10.9199 6.07031 10.6738C6.31641 10.4277 6.76758 10.4277 7.01367 10.6738L9.1875 12.8477L13.9453 8.04883C14.1914 7.80273 14.6426 7.80273 14.8887 8.04883C15.1348 8.29492 15.1348 8.74609 14.8887 8.99219L9.63867 14.2422ZM21 11.125C21 16.9492 16.2832 21.625 10.5 21.625C4.67578 21.625 0 16.9492 0 11.125C0 5.3418 4.67578 0.625 10.5 0.625C16.2832 0.625 21 5.3418 21 11.125ZM10.5 1.9375C5.41406 1.9375 1.3125 6.08008 1.3125 11.125C1.3125 16.2109 5.41406 20.3125 10.5 20.3125C15.5449 20.3125 19.6875 16.2109 19.6875 11.125C19.6875 6.08008 15.5449 1.9375 10.5 1.9375Z"
              fill="#4B4B4B"
            />
          </svg>
          <p class="section-paragraph-s text-start mb-0">
            Better resource allocation through incident prioritization
          </p>
        </div>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <img
        src="/assets/img/feature-pages/infraon-itsm/incident/incident-management-feature-4.webp"
        class="w-100"
        style="box-shadow: none"
        alt="it asset management software"
      />
    </div>
  </div>
</section>

<section class="container section-spacing">
  <div id="gdpr-wrapper">
    <div class="gdpr-section justify-content-center">
      <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100" />
      <div>
        <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
        <p class="section-paragraph mb-0">
          We are compliant with the European General Data Protection Regulation (GDPR) – and <br />
          our SaaS-based product suite is fully committed to protecting the data of our customers
          <br />
          as per the recent standards.
        </p>
      </div>
    </div>
  </div>
</section>

<section class="section-spacing bg-grey">
  <div class="container">
    <h2 class="section-title text-center">Discover Additional ITSM Features by Infraon</h2>

    <div class="row mx-0">
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
        <div class="backlink-container bg-white h-100" style="border: 1px solid #0000001c">
          <a
            routerLink="/itsm-tool/features/sla-management-solution"
            aria-label="Know more about SLA Management Solution"
          >
            <img
              class="feature-icon"
              src="/assets/img/feature-pages/infraon-itsm/incident/sla-mgmt.svg"
              alt="SLA Management Solution icon"
            />
            <p class="section-title-s text-start">SLA Management Solution</p>
            <p>
              Custom SLA templates handle escalations, improving satisfaction and ensuring
              compliance requirements.
            </p>
          </a>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
        <div class="backlink-container bg-white h-100" style="border: 1px solid #0000001c">
          <a
            routerLink="/itsm-tool/features/event-management"
            aria-label="Know more about Event Management"
          >
            <img
              class="feature-icon"
              src="/assets/img/feature-pages/infraon-itsm/incident/event-mgmt.svg"
              alt="Event Management icon"
            />
            <p class="section-title-s text-start">Event Management</p>
            <p>Real-time event detection and collection with API-based data and service context.</p>
          </a>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
        <div class="backlink-container bg-white h-100" style="border: 1px solid #0000001c">
          <a
            routerLink="/itsm-tool/features/catalog-management"
            aria-label="Know more about Service catalogue Management"
          >
            <img
              class="feature-icon"
              src="/assets/img/feature-pages/infraon-itsm/incident/service-catalogue-mgmt.svg"
              alt="Service catalogue Management icon"
            />
            <p class="section-title-s text-start">Service catalogue Management</p>
            <p>Centralized repository of available IT services for easy request and fulfillment.</p>
          </a>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
        <div class="backlink-container bg-white h-100" style="border: 1px solid #0000001c">
          <a
            routerLink="/itsm-tool/features/service-request-management"
            aria-label="Know more about Service Request Management"
          >
            <img
              class="feature-icon"
              src="/assets/img/feature-pages/infraon-itsm/incident/service-mgmt.svg"
              alt="Service Request Management icon"
            />
            <p class="section-title-s text-start">Service Request Management</p>
            <p>
              Streamlined handling of user requests with automated workflows and efficient resource
              allocation.
            </p>
          </a>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
        <div class="backlink-container bg-white h-100" style="border: 1px solid #0000001c">
          <a
            routerLink="/itsm-tool/features/change-management-software"
            aria-label="Know more about Change Management"
          >
            <img
              class="feature-icon"
              src="/assets/img/feature-pages/infraon-itsm/incident/change-mgmt.svg"
              alt="Change Management icon"
            />
            <p class="section-title-s text-start">Change Management</p>
            <p>
              Systematic handling of IT changes reduces risk and ensures controlled service updates.
            </p>
          </a>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
        <div class="backlink-container bg-white h-100" style="border: 1px solid #0000001c">
          <a
            routerLink="/itsm-tool/features/workflow-automation"
            aria-label="Know more about Workflow Automation"
          >
            <img
              class="feature-icon"
              src="/assets/img/feature-pages/infraon-itsm/incident/workflow-mgmt.svg"
              alt="Workflow Automation icon"
            />
            <p class="section-title-s text-start">Workflow Automation</p>
            <p>
              Custom automated workflows streamline processes and enable business rule
              implementation.
            </p>
          </a>
        </div>
      </div>
    </div>

    <div class="row mx-0 justify-content-center pt-4">
      <a [routerLink]="['/sitemap']" [queryParams]="{ group: 'ITSM' }" class="primary-button"
        >Checkout more features</a
      >
    </div>
  </div>
</section>

<section class="section-spacing bg-grey">
  <div class="container" id="g2-box-wrapper">
    <div class="g2-box justify-content-between">
      <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo" />
      <p>
        Already love using our products? Please <br />
        share your experiences on G2
      </p>
      <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button"
        >Rate us</a
      >
    </div>
  </div>
</section>

<app-faqs [faqs]="faqs" [theme]="'itsm-theme'"></app-faqs>
